import { Component, Object3D } from '@wonderlandengine/api';
import { property } from '@wonderlandengine/api/decorators.js';
import { TriggerTarget } from '../interactions/triggerTarget.js';
import { Door } from '../interactions/door.js';

export class UnlockDoor extends Component {
    static TypeName = 'unlock-door';
    private _triggerTarget?: TriggerTarget | null;

    @property.object({ required: true })
    door!: Object3D;

    start(): void {
        this._triggerTarget = this.object.getComponent(TriggerTarget)!;
    }

    onActivate(): void {
        this._triggerTarget?.onExecute.add(this._onExecute);
    }

    onDeactivate(): void {
        this._triggerTarget?.onExecute.remove(this._onExecute);
    }

    private _onExecute = () => {
        this.door.getComponent(Door)?.unlock();
    };
}
